import { verdictColor } from '../lib/status.js';

export function VerdictPill({ verdict }: { verdict?: string | null }) {
  const value = verdict && verdict.length > 0 ? verdict : 'UNKNOWN';
  return (
    <span className={`pill pill-${verdictColor(value)}`} data-testid="verdict-pill">
      {value}
    </span>
  );
}
